import React, { Component } from 'react'
import './preview.scss';
import intl from 'react-intl-universal';
import { store } from '@/store/store.index'
import { getQueryVariable } from 'Utils/utils'
import { Image, Button, Input, message, Tooltip } from 'antd';
import EyeIcon from '../components/icon/eye';
import MessageIcon from '../components/icon/message';
import { Swiper, SwiperItem } from '../components/swiper';
import Loading from '../components/loading/index';
import { DEVICE_DETACTION } from '../utils/device';
const { TextArea } = Input;

class Preview extends Component {
    constructor (props) {
        super(props);
        this.state = {
            showLoading: false,
            showTextArea: false,
            suggest: '',
            info: {},
            recommendedList: []
        }
    }
    componentDidMount () {
        this.isDebug = getQueryVariable('debug');
        store.apiStore.onGetUser({}, () => {
            this.apiGetTemplateInfo();
        });
        this.id = this.props.id || getQueryVariable('id');
        this.cid = this.props.cid;
    }
    apiGetToken (callback) {
        let token = store.appStore.token;
        if (!token) {
            store.apiStore.onGetUser({}, () => {
                if (store.appStore.token) {
                    callback();
                } else {
                    // Client initiates the call and returns login result information
                    window.LoginCallback = (data, from = 0) => {
                        !!this.isDebug && console.log('=LoginCallback=', from, JSON.stringify(data));
                        store.appStore.token = data && data.token;
                        if (store.appStore.token) {
                            callback();
                        } else {
                            message.warning(intl.formatMessage({ id: 'AccountError' }));
                        }
                    }
                    store.apiStore.onLogin({}, () => {
                        LoginCallback({ token: store.appStore.token }, 1)
                    });
                }
            });
        } else {
            callback();
        }
    }
    // Open template
    apiOpenTemplate = () => {
        const { info: templateInfo } = this.state;
        const { token, baseUrl} = store.appStore;
        const openTemplate = () => {
            const platform = getQueryVariable('platform');
            store.apiStore.onOpenFoxitTemplate({
                templateId: templateInfo.id,
                pdf_url: `${baseUrl}/api/file/download?type=pdf&filepath=${templateInfo.pdf}`,
                image: `${baseUrl}/api/file/download?type=pdf&filepath=${templateInfo.image}`,
                name: templateInfo.name,
                pdf_hash: templateInfo.pdf_hash,
                pdf_size: templateInfo.pdf_size
            }, (data) => {
                if ((data && data.ret == 0) || ['PhantomOnline'].includes(platform)) {
                    this.props.onCancel();
                }
            });
        };
        
        if (token) {
            store.apiStore.apiPostTemplateUse({
                access_token: token,
                template_id: templateInfo.id
            }, openTemplate);
        } else {
            openTemplate();
        }
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'OpenFoxitTemplate', 
            extraInformation: {
                templateId: templateInfo.id,
                templateName: templateInfo.name
            }
        });
    }
    // Fetch template details
    apiGetTemplateInfo = () => {
        this.showLoading();
        // Click count
        store.apiStore.apiPostTemplateClicks({
            access_token: store.appStore.token,
            template_id: this.id
        });
        return store.apiStore.apiGetTemplateInfo({ template_id: this.id }, res => {
            const info = res.data.info;
            this.cid = info.category_id;
            this.setState({ info }, () => {
                this.apiGetClicksRank(this.hideLoading);
                this.activeEditFocus();
            });
        });
    }
    // Fetch template ranking
    apiGetClicksRank = (callback) => {
        return store.apiStore.apiGetClicksRank({ 
            category_id: this.cid,
            pagesize: 3,
            page: 1
        }, res => {
            const { info } = this.state;
            const list = res.data.lists;
            const recommendedList = [];
            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                if (info.id === element.id) continue;
                if (recommendedList.length === 2) break;
                recommendedList.push(element);
            }
            this.setState({ recommendedList });
            callback && callback();
        });
    }
    // Submit suggestion
    apiPostComment = () => {
        this.showLoading();
        const { token } = store.appStore;
        const content = this.state.suggest.trim();
        if (!token) {
            this.hideLoading();
            message.warning(intl.formatMessage({ id: 'AccountError' }));
            return ;
        }
        if (!content) {
            this.hideLoading();
            message.warning(intl.formatMessage({ id: 'SuggestContentRequired' }));
            return ;
        }
        store.apiStore.apiPostComment({ 
            access_token: token,
            template_id: this.id,
            content
        }, (res) => {
            this.hideLoading();
            if (res.ret !== 0) {
                message.warning(intl.formatMessage({ id: 'netWorkError' }));
                return ;
            }
            message.success(intl.formatMessage({ id: 'SuggestSubmitSuccess' }));
            this.setState({
                suggest: '',
                showTextArea: false
            });
        });
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'Suggest', 
            extraInformation: {
                templateId: this.id,
                content
            }
        });
    }
    // App opens a new window
    apiNavigateTo = (templateInfo, failCallback) => {
        let locationSearch = location.search;
        let locationSearchJsonStr = '{"' + locationSearch.replaceAll('?', '').replaceAll('&', '","').replaceAll('=', '":"') + '"}';
        const locationSearchJson = JSON.parse(locationSearchJsonStr);
        locationSearchJson.id = templateInfo.id;
        locationSearchJson.cid = templateInfo.category_id;
        locationSearchJsonStr = JSON.stringify(locationSearchJson);
        locationSearch = '?' + locationSearchJsonStr.replace(/[{}"]/g, '').replaceAll(':', '=').replaceAll(',', '&');
        let url = location.origin + '/preview' + locationSearch;
        store.apiStore.onNavigateTo({
            title: templateInfo.name,
            close_other: true,
            url
        }, (res) => {
            // NavigateTo method not recognized
            if (!res || res.ret !== 0) {
                failCallback && failCallback();
            }
        });
    }

    // Show or hide loading indicator
    showLoading = () => {
        this.setState({ showLoading: true });
    }
    hideLoading = () => {
        this.setState({ showLoading: false });
    }

    onTextAreaChange = (e) => {
        this.setState({ suggest: e.target.value });
    }

    // Suggest button click
    onClickSuggest = () => {
        const { showTextArea } = this.state;
        if (location && location.href.endsWith('ljh')) {
            this.setState({ showTextArea: !showTextArea });
            return;
        }
        this.apiGetToken(() => {
            this.setState({ showTextArea: !showTextArea });
        });
    }
    // Submit button click
    onClickSubmit = () => {
        this.apiPostComment();
    }
    // Click recommended template
    onClickRecommend = (info) => {
        // Analytics event
        store.userStore.doSendGAEvent({
            eventKey: 'ClickRecommend', 
            extraInformation: {
                templateId: info.id,
                templateName: info.name
            }
        });

        const platform = getQueryVariable('platform'); // Phantom FoxitReader PhantomOnline MacPhantom Android IOS
        // const isPad = getQueryVariable('isPad'); // 0: not pad, 1: pad
        if (['Android', 'IOS'].includes(platform)) {
            // App opens a new window
            this.apiNavigateTo(info);
        } else {
            this.id = info.id;
            this.cid = info.category_id;
            this.apiGetTemplateInfo();
        }
    }
    // Enter key handler    
    onKeyDown = (e, type, arg1) => {
        if (e.keyCode == 13 || e.keyCode == 32) {
            e.stopPropagation();
            e.preventDefault();
            switch (type) {
                case 'suggest':
                    this.onClickSuggest();
                    break;
                case 'submit':
                    this.onClickSubmit();
                    break;
                case 'edit':
                    this.apiOpenTemplate();
                    break;
                case 'recommended':
                    this.onClickRecommend(arg1);
                    break;
            }
        }
    }
    // Activate Edit button focus
    activeEditFocus = () => {
        const { touch } = DEVICE_DETACTION;
        if (touch) return ;
        const $editButton = document.querySelector('.edit-btn-wrapper > button');
        $editButton && $editButton.focus();
    }

    render () {
        const { showLoading, showTextArea, info, recommendedList } = this.state;
        const { baseUrl } = store.appStore;
        const platform = getQueryVariable('platform'); // Phantom FoxitReader PhantomOnline MacPhantom Android IOS
        const isPad = getQueryVariable('isPad'); // 0: not pad, 1: pad
        const Suggest = intl.formatMessage({ id: 'Suggest' });
        const Suggestion = intl.formatMessage({ id: 'Suggestion' });
        const Submit = intl.formatMessage({ id: 'Submit' });
        const EditNow = intl.formatMessage({ id: 'EditNow' });
        const Recommended = intl.formatMessage({ id: 'Recommended' });
        const { mobile, ios, android, iphone, ipad, touch } = DEVICE_DETACTION;
        let tabIndex = 0;
        if (touch || mobile || ios || android || iphone || ipad) {
            tabIndex = null;
        }
        
        return (
            <div className="page-preview">
                {
                    info.id !== undefined && 
                    <section className="left-part custom-scrollbar">
                        {
                            (info.preview_image||[]).map((item,index)=>(
                                <Image key={index} className="thumbnail-image" preview={false} src={`${baseUrl}/api/file/download?type=img&filepath=${item}`} />
                            ))
                        }
                    </section>
                }
                {
                    info.id !== undefined && 
                    <section className="right-part">
                        <div className="right-part-header">
                            <div className="title mb-15"><Tooltip title={info.name} placement="bottomLeft">{info.name}</Tooltip></div>
                            {
                                ['Android', 'IOS'].includes(platform) && isPad == 0 && 
                                <Swiper className="mb-20" autoPlay={false} style={{height:240}}>
                                    {
                                        (info.preview_image||[]).map((item,index)=>(
                                            <SwiperItem key={index}><Image className="thumbnail-image" preview={false} src={`${baseUrl}/api/file/download?type=img&filepath=${item}`} /></SwiperItem>
                                        ))
                                    }
                                </Swiper>
                            }
                            <div className="jc-sb mb-10">
                                <span>
                                    <EyeIcon className="mr-5"></EyeIcon>{info.clicks||0}
                                </span>
                                <span className="icon-suggest" role="button" aria-pressed={showTextArea} tabIndex={tabIndex} onKeyDown={(e)=>this.onKeyDown(e,'suggest')} onClick={this.onClickSuggest}>
                                    <MessageIcon className={`mr-5${showTextArea?' active':''}`}></MessageIcon>{Suggest}
                                </span>
                            </div>
                            {
                                showTextArea && 
                                <TextArea className="suggest-area" showCount maxLength={140} style={{height:58}} placeholder={Suggestion} onChange={this.onTextAreaChange} />
                            }
                            {
                                showTextArea && 
                                <div className="mt-30 jc-fe"><Button className="btn-submit" tabIndex={tabIndex} onClick={this.onClickSubmit}>{Submit}</Button></div>
                            }
                            {
                                !(['Android', 'IOS'].includes(platform) && isPad == 0) && 
                                <div className="edit-btn-wrapper mt-30"><Button tabIndex={tabIndex} block type="primary" onClick={this.apiOpenTemplate}>{EditNow}</Button></div>
                            }
                        </div>
                        <div className="mt-48 recommended-list">
                            <div className="title">{Recommended}</div>
                            {
                                (recommendedList||[]).map((item,index)=>(
                                    <div key={index} className="recommended-list-item" role="button" aria-label={item.name} tabIndex={tabIndex} onKeyDown={(e)=>this.onKeyDown(e,'recommended',item)} onClick={()=>this.onClickRecommend(item)}>
                                        <div className="recommended-list-item-left">
                                            <Image className="thumbnail-image" preview={false} src={`${baseUrl}/api/file/download?type=img&filepath=${item.image}`}/>
                                        </div>
                                        <div className="recommended-list-item-right">
                                            <div className="recommended-list-item-right-name">{item.name}</div>
                                            <div className="recommended-list-item-right-count"><EyeIcon className="mr-5" />{item.clicks}</div>
                                        </div>
                                    </div>
                                ))
                                
                            }
                        </div>
                        {
                            ['Android', 'IOS'].includes(platform) && isPad == 0 &&
                            <div className="edit-btn-wrapper mobile-btn"><Button block type="primary" onClick={this.apiOpenTemplate}>{EditNow}</Button></div>
                        }
                    </section>
                }
                {
                    showLoading && 
                    <Loading center={true}></Loading>
                }
            </div>
        )
    }
}
export default Preview;